import { Static, Object, String, Array, Number, Record, Omit, Optional } from '@sinclair/typebox';

import { DapiError, DapiWarning, DapiDictionariesFlight, DapiDictionariesLocation } from '../dapi/common';

export const AlternativeOffersQueryParams = Object({
  pnr: String(),
  lastName: String(),
  alternativeOfferBoundId: String(),
  alternativeDate: Optional(String()),
  officeId: String(),
});
export type AlternativeOffersQueryParams = Static<typeof AlternativeOffersQueryParams>;

export const AlternativeOffersSegment = Object({ id: String(), bookingClass: String() });
export type AlternativeOffersSegment = Static<typeof AlternativeOffersSegment>;

const AlternativeOfferAir = Object({
  bound: Object({
    originLocationCode: String(),
    destinationLocationCode: String(),
    duration: Number(),
    flights: Array(AlternativeOffersSegment),
  }),
});
type AlternativeOfferAir = Static<typeof AlternativeOfferAir>;

export const AlternativeOfferFlight = Object({
  type: String(),
  id: String(),
  expiryDateTime: String(),
  air: AlternativeOfferAir,
});
export type AlternativeOfferFlight = Static<typeof AlternativeOfferFlight>;

export const AlternativeOfferDictionariesFlight = Omit(DapiDictionariesFlight, [
  'isOpenSegment',
  'isInformational',
  'secureFlightIndicator',
  'meals',
  'flightStatus',
  'aircraftConfigurationVersion',
]);
export type AlternativeOfferDictionariesFlight = Static<typeof AlternativeOfferDictionariesFlight>;

export const AlternativeOffersResponse = Object({
  data: Array(AlternativeOfferFlight),
  dictionaries: Object({
    airline: Record(String(), String()),
    location: Record(String(), DapiDictionariesLocation),
    flight: Record(String(), AlternativeOfferDictionariesFlight),
    aircraft: Record(String(), String()),
  }),
  errors: Optional(Array(DapiError)),
  warnings: Optional(Array(DapiWarning)),
});
export type AlternativeOffersResponse = Static<typeof AlternativeOffersResponse>;
